import React from "react"

import {FieldGlistGroupProps} from "../../../../../render/glist/glist-group"

export default function FieldDocumentType_GlistGroupStandard(props:FieldGlistGroupProps) {

    const noteType = gd.session.noteTypes.get(props.data.value)

    return (
        <div className="group-cards">
            <div className={Classes('icon ui5-ico-12 m-r-10', gd.const.note.icon[noteType.icon])}/>
            <div className="text">{noteType.name}</div>
            {!!props.data.isCollapsed && <div className="counter">{props.data.counter}</div>}

            {!props.data.isCollapsed &&
                <div className="group-corners">
                    <div className="top-corner"/>
                </div>}
        </div>
    )

}
